module.exports = __webpack_public_path__ + "static/media/logo_01.993e9a34.png";